import * as Yup from 'yup'

export interface IUserRealtorSchema {
    name: string
    email: string
    creci: string
    estateAgency: string
    phone: string
}

const userRealtorSchema: Yup.SchemaOf<IUserRealtorSchema> = Yup.object()
    .shape({
        name: Yup.string().required('Nome é de usuário obrigatório').max(50, 'Máx 50 caracteres'),
        email: Yup.string().required('E-mail é obrigatório').email('E-mail inválido').max(100, 'Máx 100 caracteres'),
        creci: Yup.string()
            .matches(/^[^eE\d]*\d{1,6}[^eE\d]*$/, 'Deve conter apenas números')
            .min(1, 'Deve conter no mínimo 1 dígito')
            .max(6, 'Deve conter 6 dígitos')
            .required('CRECI é obrigatório'),
        phone: Yup.string()
            .required('Celular é obrigatório')
            .matches(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, 'Celular inválido')
            .max(15, 'Máx 15 caracteres'),
    })
    .required()

export default userRealtorSchema
